import React from 'react';
export function General() {
  return <div data-id="element-3598">
      <h1 className="text-2xl font-semibold text-gray-800 mb-2" data-id="element-3599">
        General Settings
      </h1>
      <p className="text-gray-600 mb-8" data-id="element-3600">
        Manage your account and application preferences
      </p>

      <div className="space-y-6" data-id="element-3601">
        {/* Company Information */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3602">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-3603">
            Company Information
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-3604">
            <div data-id="element-3605">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3606">
                Company Name
              </label>
              <input type="text" placeholder="Enter company name" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3607" />
            </div>
            <div data-id="element-3608">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3609">
                Industry
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3610">
                <option data-id="element-3611">Automotive</option>
                <option data-id="element-3612">Technology</option>
                <option data-id="element-3613">Retail</option>
              </select>
            </div>
          </div>
        </div>

        {/* Regional Settings */}
        <div className="bg-white rounded-lg border border-gray-200 p-6" data-id="element-3614">
          <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-3615">
            Regional Settings
          </h2>
          <div className="grid grid-cols-2 gap-4" data-id="element-3616">
            <div data-id="element-3617">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3618">
                Timezone
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3619">
                <option data-id="element-3620">Asia/Kolkata (IST)</option>
                <option data-id="element-3621">America/New_York (EST)</option>
                <option data-id="element-3622">Europe/London (GMT)</option>
              </select>
            </div>
            <div data-id="element-3623">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-3624">
                Currency
              </label>
              <select className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-3625">
                <option data-id="element-3626">INR (₹)</option>
                <option data-id="element-3627">USD ($)</option>
                <option data-id="element-3628">EUR (€)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="flex justify-end" data-id="element-3629">
          <button className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors font-medium" data-id="element-3630">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
}